module.exports = __webpack_public_path__ + "img/jane_birkin.ccf8230a.jpg";